import {
    ISoundsConfig,
    IVersionConfig,
    IAssetsConfig,
    IConnectionConfiguration,
    ICurrenciesConfig,
    IGameConfig,
    TIntegrationConfig,
    IUILayerConfig,
    IGameListConfig,
    ITextsConfig
} from './Configs';

export const CASINO_ID_WILDCARD = '<casinoId>';

export enum EConfigurationNames {
    VERSION = 'version',
    GAME_LIST = 'gameList',
    ASSETS = 'assets',
    GAME = 'game',
    UI_LAYER = 'uiLayer',
    SOUNDS = 'sounds',
    CONNECTION = 'connection',
    LANGUAGE_PL = 'languagePL',
    LANGUAGE_EN = 'languageEN',
    LANGUAGE_CS = 'languageCS',
    LANGUAGE_SK = 'languageSK',
    LANGUAGE_RO = 'languageRO',
    LANGUAGE_HR = 'languageHR',
    INTEGRATION = 'integration',
    CURRENCIES = 'currencies',
    TEXTS = 'texts'
}

export const CONFIGURATION_FILES = {
    [EConfigurationNames.VERSION]: 'version.json',
    [EConfigurationNames.GAME_LIST]: 'game-list.json',
    [EConfigurationNames.ASSETS]: 'assets_configuration.json',
    [EConfigurationNames.GAME]: 'game_configuration.json',
    [EConfigurationNames.UI_LAYER]: 'ui_layer.json',
    [EConfigurationNames.SOUNDS]: 'sounds_configuration.json',
    [EConfigurationNames.CONNECTION]: 'connection_configuration.json',
    [EConfigurationNames.LANGUAGE_PL]: 'language_pl.json',
    [EConfigurationNames.LANGUAGE_EN]: 'language_en.json',
    [EConfigurationNames.LANGUAGE_CS]: 'language_cs.json',
    [EConfigurationNames.LANGUAGE_SK]: 'language_sk.json',
    [EConfigurationNames.LANGUAGE_RO]: 'language_ro.json',
    [EConfigurationNames.LANGUAGE_HR]: 'language_hr.json',
    [EConfigurationNames.INTEGRATION]: `${CASINO_ID_WILDCARD}-config.json`,
    [EConfigurationNames.CURRENCIES]: 'currencies_configuration.json',
    [EConfigurationNames.TEXTS]: 'texts_configuration.json'
};

export interface ISingleImageData {
    langSelector: boolean;
    commonSrc: string;
    src: string;
    alt: string;
    styles: string;
    stylesPortrait: string;
    stylesHorizontal: string;
}

export interface IHelpItemDescription {
    text: string;
    textByKey: string;
    image: ISingleImageData;
    imageArray: Array<ISingleImageData>;
}
export interface IHelpItem {
    item: {
        text: string;
        image: ISingleImageData;
        imageArray: Array<ISingleImageData>;
    };
    description: IHelpItemDescription;
}

export interface IPaytableSymbolItem {
    description: string;
}

export interface ILanguagePack {
    [key: string]: string | { [key: string]: string } | { [key: string]: IHelpItem } | { [key: string]: IPaytableSymbolItem };
    TEXT_BY_KEY: { [key: string]: string };
    HELP_CONTENT: { [key: string]: IHelpItem };
    PAYTABLE_SYMBOLS_DESCRIPTION: { [key: string]: { description: string } };
}
export interface IConfigurations {
    [EConfigurationNames.VERSION]: IVersionConfig;
    [EConfigurationNames.GAME_LIST]: IGameListConfig;
    [EConfigurationNames.ASSETS]: IAssetsConfig;
    [EConfigurationNames.SOUNDS]: ISoundsConfig;
    [EConfigurationNames.GAME]: IGameConfig;
    [EConfigurationNames.UI_LAYER]: IUILayerConfig;
    [EConfigurationNames.CONNECTION]: IConnectionConfiguration;
    [EConfigurationNames.LANGUAGE_PL]: ILanguagePack;
    [EConfigurationNames.LANGUAGE_EN]: ILanguagePack;
    [EConfigurationNames.LANGUAGE_CS]: ILanguagePack;
    [EConfigurationNames.LANGUAGE_SK]: ILanguagePack;
    [EConfigurationNames.LANGUAGE_RO]: ILanguagePack;
    [EConfigurationNames.LANGUAGE_HR]: ILanguagePack;
    [EConfigurationNames.INTEGRATION]: TIntegrationConfig;
    [EConfigurationNames.CURRENCIES]: ICurrenciesConfig;
    [EConfigurationNames.TEXTS]: ITextsConfig;
}
